import { tickerHeadlines } from '@/mocks/ticker';

export default function TopTicker() {
  const loop = tickerHeadlines.concat(tickerHeadlines);

  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="flex items-center gap-3 md:gap-4 h-10 px-4 md:px-6">
        <div className="flex items-center gap-2 whitespace-nowrap shrink-0">
          <span className="relative flex w-2 h-2 items-center justify-center">
            <span className="absolute w-2 h-2 rounded-full bg-primary-400 animate-pulse-soft"></span>
            <span className="relative w-2 h-2 rounded-full bg-primary-500"></span>
          </span>
          <span className="font-label font-medium text-xs text-primary-300">实时更新</span>
        </div>
        <span className="hidden sm:block w-px h-4 bg-background-800"></span>
        <div className="flex-1 overflow-hidden">
          <div className="ticker-track animate-marquee">
            {loop.map((headline, i) => (
              <span key={`${headline}-${i}`} className="inline-flex items-center text-xs text-background-200">
                <span className="px-5">{headline}</span>
                <span className="text-primary-500">/</span>
              </span>
            ))}
          </div>
        </div>
        <a
          href="#tougao"
          className="hidden md:inline-flex items-center gap-1.5 shrink-0 whitespace-nowrap text-xs text-primary-300 hover:text-primary-200 cursor-pointer transition-colors"
        >
          <i className="ri-send-plane-fill"></i>
          我要投稿
        </a>
      </div>
    </div>
  );
}